export function isTodayUTC(datetimeMillis: number) {
  const date = new Date(datetimeMillis)
  const now = new Date()

  return (
    date.getUTCDate() === now.getUTCDate() &&
    date.getUTCMonth() === now.getUTCMonth() &&
    date.getUTCFullYear() === now.getUTCFullYear()
  )
}
